import React from 'react'

const SupplyPlanning = () => {
  return (
    <div>SupplyPlanning</div>
  )
}

export default SupplyPlanning